import { db } from '../firebase';
import { doc, getDoc, setDoc, updateDoc, increment } from 'firebase/firestore';

// Increment the view count for a specific property
export const incrementPropertyView = async (propertyId) => {
    try {
        // Prevent duplicate counting
        const viewKey = `property_viewed_${propertyId}`;
        if (sessionStorage.getItem(viewKey) === 'true') {
            return true;
        }
        
        // Get the main properties document
        const propertiesDocRef = doc(db, 'properties', 'allproperties');
        const docSnap = await getDoc(propertiesDocRef);
        
        if (docSnap.exists() && docSnap.data()[propertyId]) {
            const currentProperty = docSnap.data()[propertyId];
            const currentViewCount = currentProperty.viewCount || 0;
            
            // Create a field path for the nested viewCount property
            await updateDoc(propertiesDocRef, {
                [`${propertyId}.viewCount`]: increment(1),
                [`${propertyId}.lastViewed`]: new Date().toISOString()
            });
            
            // Mark this property as viewed in this session
            sessionStorage.setItem(viewKey, 'true');
            return true;
        }
        
        return false;
    } catch (error) {
        console.error("Error updating property view count:", error);
        return false;
    }
};

// Track site visit by incrementing a counter in Firestore
export const trackSiteVisit = async () => {
    try {
        // Prevent duplicate tracking
        if (sessionStorage.getItem('session_visit_counted') === 'true') {
            return true;
        }
        
        const statsDocRef = doc(db, 'statistics', 'siteStats');
        const docSnap = await getDoc(statsDocRef);
        
        if (docSnap.exists()) {
            // Update existing stats document
            await updateDoc(statsDocRef, {
                totalVisits: increment(1),
                lastVisit: new Date().toISOString()
            });
        } else {
            // Create stats document if it doesn't exist
            await setDoc(statsDocRef, {
                totalVisits: 1,
                lastVisit: new Date().toISOString()
            });
        }
        
        // Mark this session as counted
        sessionStorage.setItem('session_visit_counted', 'true');
        return true;
    } catch (error) {
        console.error("Error tracking site visit:", error);
        return false;
    }
};

// Get site statistics
export const getSiteStatistics = async () => {
    try {
        const statsDocRef = doc(db, 'statistics', 'siteStats');
        const docSnap = await getDoc(statsDocRef);
        
        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            return { totalVisits: 0, lastVisit: null };
        }
    } catch (error) {
        console.error("Error getting site statistics:", error);
        return { totalVisits: 0, lastVisit: null, error: error.message };
    }
};
